import React from 'react';
import '../styles/Policies.css';

const OpenAccessPolicy = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="policy-hero">
        <div className="container">
          <h1 className="policy-hero-title">
            <i className="fas fa-unlock-alt me-3"></i>
            Open Access Policy
          </h1>
          <p className="policy-hero-subtitle">
            Making knowledge freely accessible to all
          </p>
        </div>
      </div>

      <div className="container py-5">
        <div className="row">
          <div className="col-lg-10 mx-auto">
          
          {/* Commitment Section */}
          <div className="policy-card" style={{ animationDelay: '0.1s' }}>
            <div className="policy-card-header">
              <h2 className="policy-card-title">
                <i className="fas fa-handshake"></i>
                Our Commitment to Open Access
              </h2>
            </div>
              <p className="card-text">
                The Federal University Wukari Journal of Agriculture and Life Sciences (FUWJALS) 
                is fully committed to open access publishing. We believe that scientific knowledge 
                should be freely available to researchers, practitioners, and the public worldwide 
                without financial, legal, or technical barriers.
              </p>
          </div>

          {/* Open Access Model */}
          <div className="policy-card" style={{ animationDelay: '0.2s' }}>
            <div className="policy-card-header">
              <h2 className="policy-card-title">
                <i className="fas fa-globe"></i>
                Open Access Model
              </h2>
            </div>
              <h4>Gold Open Access</h4>
              <p className="card-text">
                FUWJALS follows the Gold Open Access model, which means:
              </p>
              <ul>
                <li>All articles are freely available immediately upon publication</li>
                <li>No subscription fees or access barriers for readers</li>
                <li>Articles are published under Creative Commons licenses</li>
                <li>Authors retain copyright of their work</li>
                <li>Global accessibility through our online platform</li>
              </ul>
              
              <div className="alert alert-success" style={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 12px rgba(40, 167, 69, 0.15)' }}>
                <h5><i className="fas fa-unlock me-2"></i>Free Access for All</h5>
                <p className="mb-0">
                  Every article published in FUWJALS is immediately and permanently available 
                  for free download, reading, and sharing worldwide.
                </p>
              </div>
          </div>

          {/* Creative Commons Licensing */}
          <div className="policy-card" style={{ animationDelay: '0.3s' }}>
            <div className="policy-card-header">
              <h2 className="policy-card-title">
                <i className="fab fa-creative-commons"></i>
                Creative Commons Licensing
              </h2>
            </div>
              <h4>CC BY 4.0 License</h4>
              <p className="card-text">
                All articles are published under the Creative Commons Attribution 4.0 
                International License (CC BY 4.0), which allows:
              </p>
              
              <div className="row">
                <div className="col-md-6">
                  <h5>You Are Free To:</h5>
                  <ul>
                    <li><strong>Share</strong> — copy and redistribute the material</li>
                    <li><strong>Adapt</strong> — remix, transform, and build upon the material</li>
                    <li><strong>Commercial use</strong> — use for any purpose, including commercially</li>
                    <li><strong>No additional restrictions</strong> — licensor cannot revoke these freedoms</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h5>Under the Following Terms:</h5>
                  <ul>
                    <li><strong>Attribution</strong> — provide appropriate credit</li>
                    <li><strong>Link to license</strong> — provide a link to the license</li>
                    <li><strong>Indicate changes</strong> — indicate if changes were made</li>
                    <li><strong>No warranties</strong> — no warranties are given</li>
                  </ul>
                </div>
              </div>
          </div>

          {/* Author Rights */}
          <div className="policy-card" style={{ animationDelay: '0.4s' }}>
            <div className="policy-card-header">
              <h2 className="policy-card-title">
                <i className="fas fa-user-shield"></i>
                Author Rights and Responsibilities
              </h2>
            </div>
              <h4>Authors Retain:</h4>
              <ul>
                <li>Full copyright ownership of their work</li>
                <li>Right to deposit in institutional repositories</li>
                <li>Right to post on personal/institutional websites</li>
                <li>Right to use in teaching and presentations</li>
                <li>Right to create derivative works</li>
                <li>Right to enter into separate agreements</li>
              </ul>
              
              <h4>Authors Grant FUWJALS:</h4>
              <ul>
                <li>Non-exclusive right to publish and distribute</li>
                <li>Right to make available under CC BY 4.0 license</li>
                <li>Right to include in indexing services</li>
                <li>Right to create preservation copies</li>
              </ul>
          </div>

          {/* Benefits */}
          <div className="policy-card" style={{ animationDelay: '0.5s' }}>
            <div className="policy-card-header">
              <h2 className="policy-card-title">
                <i className="fas fa-chart-line"></i>
                Benefits of Open Access
              </h2>
            </div>
              <div className="row">
                <div className="col-md-6">
                  <h4>For Authors</h4>
                  <ul>
                    <li>Increased visibility and citations</li>
                    <li>Global reach and impact</li>
                    <li>Faster dissemination of research</li>
                    <li>Compliance with funder mandates</li>
                    <li>Enhanced career opportunities</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h4>For Readers</h4>
                  <ul>
                    <li>Free access to high-quality research</li>
                    <li>No institutional subscription required</li>
                    <li>Immediate availability upon publication</li>
                    <li>Mobile and device-friendly access</li>
                    <li>Ability to share and collaborate</li>
                  </ul>
                </div>
              </div>
          </div>

          {/* Funding */}
          <div className="policy-card" style={{ animationDelay: '0.6s' }}>
            <div className="policy-card-header">
              <h2 className="policy-card-title">
                <i className="fas fa-coins"></i>
                Funding and Sustainability
              </h2>
            </div>
              <h4>Article Processing Charges (APCs)</h4>
              <p className="card-text">
                To maintain the open access model, FUWJALS charges authors a modest 
                article processing charge upon acceptance:
              </p>
              <ul>
                <li>Standard fee: $200 USD</li>
                <li>Covers peer review, editing, and publishing costs</li>
                <li>Waivers available for developing countries</li>
                <li>Student discounts available</li>
              </ul>
              
              <h4>Institutional Support</h4>
              <ul>
                <li>Federal University Wukari provides infrastructure</li>
                <li>Faculty volunteer their expertise</li>
                <li>Government and grant support</li>
                <li>Partnership with international organizations</li>
              </ul>
          </div>
          
          {/* Archiving */}
          <div className="policy-card" style={{ animationDelay: '0.7s' }}>
            <div className="policy-card-header">
              <h2 className="policy-card-title">
                <i className="fas fa-archive"></i>
                Archiving and Preservation
              </h2>
            </div>
              <h4>Long-term Preservation</h4>
              <p className="card-text">
                FUWJALS ensures long-term preservation and accessibility through:
              </p>
              <ul>
                <li>LOCKSS (Lots of Copies Keep Stuff Safe) network</li>
                <li>CLOCKSS (Controlled LOCKSS) preservation</li>
                <li>Portico digital preservation service</li>
                <li>Institutional repository deposits</li>
                <li>National library archiving programs</li>
              </ul>
              
              <h4>Digital Object Identifiers (DOIs)</h4>
              <ul>
                <li>Permanent DOI assigned to each article</li>
                <li>Ensures persistent access and citation</li>
                <li>CrossRef membership for metadata distribution</li>
                <li>Integration with discovery services</li>
              </ul>
          </div>
          
          {/* Indexing */}
          <div className="policy-card" style={{ animationDelay: '0.8s' }}>
            <div className="policy-card-header">
              <h2 className="policy-card-title">
                <i className="fas fa-search"></i>
                Indexing and Discovery
              </h2>
            </div>
              <h4>Current Indexing</h4>
              <ul>
                <li>Directory of Open Access Journals (DOAJ)</li>
                <li>Google Scholar</li>
                <li>BASE (Bielefeld Academic Search Engine)</li>
                <li>African Journals Online (AJOL)</li>
                <li>CrossRef</li>
              </ul>
              
              <h4>Application in Progress</h4>
              <ul>
                <li>Scopus</li>
                <li>Web of Science</li>
                <li>PubMed Central (PMC)</li>
                <li>CAB Abstracts</li>
                <li>AGRIS (FAO)</li>
              </ul>
          </div>
          
          {/* Quality */}
          <div className="policy-card" style={{ animationDelay: '0.9s' }}>
            <div className="policy-card-header">
              <h2 className="policy-card-title">
                <i className="fas fa-award"></i>
                Quality Assurance
              </h2>
            </div>
              <h4>Editorial Standards</h4>
              <p className="card-text">
                Open access does not mean compromised quality. FUWJALS maintains 
                rigorous editorial standards:
              </p>
              <ul>
                <li>Double-blind peer review process</li>
                <li>Expert editorial board</li>
                <li>Plagiarism detection software</li>
                <li>Statistical review when appropriate</li>
                <li>Professional copy-editing and formatting</li>
              </ul>
          </div>
          
          {/* Compliance */}
          <div className="policy-card" style={{ animationDelay: '1.0s' }}>
            <div className="policy-card-header">
              <h2 className="policy-card-title">
                <i className="fas fa-check-circle"></i>
                Compliance with Mandates
              </h2>
            </div>
              <h4>Funder Requirements</h4>
              <p className="card-text">
                Publishing in FUWJALS helps authors comply with open access mandates from:
              </p>
              <div className="row">
                <div className="col-md-6">
                  <h5>International Funders</h5>
                  <ul>
                    <li>Wellcome Trust</li>
                    <li>Gates Foundation</li>
                    <li>EU Horizon 2020</li>
                    <li>NIH Public Access Policy</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h5>Regional Requirements</h5>
                  <ul>
                    <li>Nigerian research council mandates</li>
                    <li>African Union research initiatives</li>
                    <li>University open access policies</li>
                    <li>Government transparency requirements</li>
                  </ul>
                </div>
              </div>
          </div>
          
          {/* Copyright */}
          <div className="policy-card" style={{ animationDelay: '1.1s' }}>
            <div className="policy-card-header">
              <h2 className="policy-card-title">
                <i className="fas fa-copyright"></i>
                Copyright and Reuse Information
              </h2>
            </div>
              <h4>How to Cite Open Access Articles</h4>
              <div className="bg-light p-3 rounded">
                <code>
                  Author, A. A. (Year). Title of article. Federal University Wukari Journal of 
                  Agriculture and Life Sciences, Volume(Issue), pages. https://doi.org/10.xxxxx/xxxx 
                  Licensed under CC BY 4.0
                </code>
              </div>
              
              <h4>Commercial Use Guidelines</h4>
              <ul>
                <li>Commercial use is permitted under CC BY 4.0</li>
                <li>Proper attribution must be provided</li>
                <li>Original source must be cited</li>
                <li>Any changes must be indicated</li>
                <li>No additional permissions required</li>
              </ul>
          </div>
          
          {/* Contact */}
          <div className="policy-card" style={{ animationDelay: '1.2s' }}>
            <div className="policy-card-header">
              <h2 className="policy-card-title">
                <i className="fas fa-envelope"></i>
                Contact Information
              </h2>
            </div>
              <p className="card-text">
                For questions about our open access policy or copyright issues:
              </p>
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <strong>Open Access Coordinator</strong><br />
                    Email: openaccess@fuwukari.edu.ng<br />
                    Phone: +234 XXX XXX XXXX
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <strong>Copyright Office</strong><br />
                    Email: copyright@fuwukari.edu.ng<br />
                    Phone: +234 XXX XXX XXXX
                  </p>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default OpenAccessPolicy;